import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import Modal from 'shared/components/modal';
import TextArea from 'src/components/text-area';
import Label from 'shared/components/label';
import {parseQueryString} from 'shared/utils';

class ReportUserModal extends React.Component {
  static propTypes = {
    reportUser: PropTypes.func,
    history: PropTypes.shape({
      goBack: PropTypes.func.isRequired,
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        _id: PropTypes.string,
      }).isRequired,
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  };

  state = {
    message: '',
  };

  handleClose = () => this.props.history.goBack();

  handleClick = () => {
    const {
      reportUser,
      match: {
        params: {_id},
      },
    } = this.props;
    reportUser(_id, this.state.message);
    this.handleClose();
  };

  setMessage = (e) => this.setState({message: e.target.value});

  render() {
    const {
      location: {search},
    } = this.props;

    return (
      <Modal show forceNotIonic>
        <Modal.TextHeader onClose={this.handleClose}>Report User</Modal.TextHeader>
        <Modal.Body>
          If you feel that {parseQueryString(search.slice(1)).name} should not be able to access
          Raise Me on behalf of your school, let us know.
          <Label>
            Explanation
            <TextArea
              value={this.state.message}
              onChange={this.setMessage}
              placeholder="Explanation (optional)"
              rows={2}
            />
          </Label>
        </Modal.Body>
        <Modal.Footer
          primaryButton={{
            text: 'Submit',
            onClick: this.handleClick,
          }}
        />
      </Modal>
    );
  }
}

export default withRouter(ReportUserModal);
